import React from "react";
import { Industries } from "../components/Industries";

export default function IndustriesPage() {
  return (
    <>
      <section className="pagehead">
        <div className="container">
          <div className="pagehead-inner">
            <div>
              <div className="section-label"><span className="dot" />Industries</div>
              <h1 className="pagehead-title display" data-testid="industries-page-h1">
                Seven industries. <em>Twenty-four sub-segments.</em> One vocabulary.
              </h1>
            </div>
            <p className="pagehead-lede">
              A common cognitive model for how capital projects are planned, designed, built and handed over — applied industry-by-industry.
            </p>
          </div>
        </div>
      </section>
      <Industries />
    </>
  );
}
